import React, { useState } from "react";

import ppeExecutionService
  from "../../services/ppeExecutionService";

export default function OperationReleaseDrawer({
  operation,
  planId,
  onClose
}) {

  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRelease = async () => {
    setLoading(true);

    try {
      await ppeExecutionService.releaseOperation(
        operation.plan_operation_id,
        {
          production_plan_id: planId,
          remarks
        }
      );
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        width: 520,
        height: "100vh",
        background: "#fff",
        boxShadow: "-2px 0 8px rgba(0,0,0,.15)",
        padding: 20,
        zIndex: 2000,
        overflowY: "auto"
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16
        }}
      >
        <h4>
          Release Operation — {operation.operation_name}
        </h4>

        <button
          className="btn btn-sm btn-light"
          onClick={onClose}
        >
          ✕
        </button>
      </div>

      <hr />

      {/* Details */}
      <div className="mb-3">
        <strong>Sequence:</strong>{" "}
        {operation.operation_seq_no}
      </div>

      <div className="mb-3">
        <strong>Status:</strong>{" "}
        {operation.status}
      </div>

      <div className="mb-3">
        <strong>Planned Time:</strong>
        <br />
        {operation.planned_start_datetime} →{" "}
        {operation.planned_end_datetime}
      </div>

      {/* Remarks */}
      <div className="mb-3">
        <label className="form-label">
          Remarks
        </label>

        <textarea
          className="form-control"
          rows={3}
          value={remarks}
          onChange={(e) =>
            setRemarks(e.target.value)
          }
        />
      </div>

      {/* Actions */}
      <div className="text-end mt-4">
        <button
          className="btn btn-secondary me-2"
          onClick={onClose}
        >
          Cancel
        </button>

        <button
          className="btn btn-success"
          onClick={handleRelease}
          disabled={loading}
        >
          {loading
            ? "Releasing..."
            : "Release Operation"}
        </button>
      </div>
    </div>
  );
}
